// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_upload_success-module__container--239UF{padding-top:120px;text-align:center}.decision_upload_success-module__title--1cNfH{font-weight:700;font-size:16px;line-height:24px;letter-spacing:0px;margin-bottom:16px}.decision_upload_success-module__text--PMCge{font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;margin-bottom:40px}\n", ""]);
// Exports
exports.locals = {
	"container": "decision_upload_success-module__container--239UF",
	"title": "decision_upload_success-module__title--1cNfH",
	"text": "decision_upload_success-module__text--PMCge"
};
module.exports = exports;
